import React from "react";
import { gql, useQuery } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography
} from "@material-ui/core";
import PlayerTournamentList from "./PlayerTournamentList";
import PlayerGameList from "./PlayerGameList";
import PlayerSplitList from "./PlayerSplitList";
import { useParams } from "react-router-dom";
import TableLink from "../TableLink";

const styles = theme => ({
  root: {
    maxWidth: 1200,
    marginTop: theme.spacing(5),
    padding: theme.spacing(2),
    overflowX: "auto",
    margin: "auto"
  }
});

const GET_PLAYER = gql`
  query playerQuery($id: Int) {
    Player(id: $id) {
      id
      name
      points
      wins
      losses
      pp20tuh
      totalTournaments
      totalGames
      schools {
        id
        short_name
      }
    }
  }
`;

function Player(props) {
  const { classes } = props;
  const { id } = useParams();

  const { loading, data, error } = useQuery(GET_PLAYER, {
    variables: {
      id: parseInt(id)
    }
  });

  return (
    <Paper className={classes.root}>
      {loading && !error && <p>Loading...</p>}
      {error && !loading && <p>Error</p>}
      {data && !loading && !error && (
        <div>
          <Typography variant="h4" gutterBottom>
            {data.Player[0].name}
          </Typography>
          <Typography variant="h6" gutterBottom>
            {data.Player[0].schools.length ? "Played for " : ""}
            {data.Player[0].schools.map((s, i) => (
              <React.Fragment key={s.id}>
                <TableLink to={`/school/${s.id}`}>{s.short_name}</TableLink>
                <span>
                  {i === data.Player[0].schools.length - 1 ? "" : ", "}
                </span>
              </React.Fragment>
            ))}
          </Typography>
          <Typography paragraph>
            <TableLink to={`/player/${data.Player[0].id}/history`}>
              View history against opponent
            </TableLink>
          </Typography>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Points</TableCell>
                <TableCell>Wins</TableCell>
                <TableCell>Losses</TableCell>
                <TableCell>PP20TUH</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Career</TableCell>
                <TableCell>{data.Player[0].points?.toLocaleString()}</TableCell>
                <TableCell>{data.Player[0].wins?.toLocaleString()}</TableCell>
                <TableCell>{data.Player[0].losses?.toLocaleString()}</TableCell>
                <TableCell>{data.Player[0].pp20tuh?.toFixed(2)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
      {data && !loading && !error && (
        <PlayerTournamentList
          playerId={parseInt(id)}
          totalTournaments={data.Player[0].totalTournaments}
        ></PlayerTournamentList>
      )}
      {data && !loading && !error && (
        <PlayerGameList
          playerId={parseInt(id)}
          totalGames={data.Player[0].totalGames}
        ></PlayerGameList>
      )}
      {data && !loading && !error && (
        <PlayerSplitList playerId={parseInt(id)}></PlayerSplitList>
      )}
    </Paper>
  );
}

export default withStyles(styles)(Player);
